var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-details"},[_c('div',{staticClass:"card-header"},[_vm._t("header",function(){return [(_vm.title)?_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }